import React from 'react';
import {Route, Routes} from 'react-router-dom'
import Home from '../domains/home/Home'
import CareUnitListContainer from '../domains/careUnit/CareUnitListContainer'
import OpticianListContainer from '../domains/optician/OpticianListContainer'
import EventListContainer from '../domains/eventLog/EventListContainer'
import ReferralContainer from '../domains/referral/ReferralContainer'
import ReferralListContainer from '../domains/referralList/ReferralListContainer'
import Error from './Error'
import RequireAuth from '../domains/session/RequireAuth'
import UserListContainer from "../domains/users/UserListContainer"
import ReportContainer from "../domains/report/ReportContainer"
import GlobalMessage from "../domains/global/GlobalMessageContainer";
import HomeInfo from "../domains/home/HomeInfo";
import OicdCallbackContainer from "../domains/session/OicdCallbackContainer";
import PrivacyPolicy from "../domains/privacy/PrivacyPolicy";
import {Container} from "react-bootstrap";

const ALL_LOGGED_IN_ROLES = ["ADMIN", "CARE_UNIT", "OPTICIAN", "CARE_UNIT_ADMIN", "OPTICIAN_ADMIN"];
const REFERRAL_CREATE_ROLES = ["ADMIN", "OPTICIAN", "OPTICIAN_ADMIN"];
const ADMIN_ONLY = ["ADMIN"];
const CARE_UNIT_ROLES = ["ADMIN", "CARE_UNIT", "CARE_UNIT_ADMIN"];
const USER_ADMIN_ROLES = ["ADMIN", "CARE_UNIT_ADMIN", "OPTICIAN_ADMIN"];

const Main = () => (
    <div className={"Main"}>
    <main>
        <Container id={"content"}>
            <GlobalMessage/>
            <Routes>
                <Route path='/' element={<Home/>}/>
                <Route path='/info' element={<HomeInfo/>}/>
                <Route path='/integritetspolicy' element={<PrivacyPolicy/>}/>
                <Route path='/error' element={<Error/>}/>
                <Route path='/oidc-callback' element={<OicdCallbackContainer/>}/>
                <Route path='/remiss' element={<RequireAuth allowedRoles={REFERRAL_CREATE_ROLES}><ReferralContainer/></RequireAuth>}/>
                <Route path='/remiss/skapa' element={<RequireAuth allowedRoles={REFERRAL_CREATE_ROLES}><ReferralContainer/></RequireAuth>}/>
                <Route path='/remiss/hitta' element={<RequireAuth allowedRoles={ALL_LOGGED_IN_ROLES}><ReferralListContainer/></RequireAuth>}/>
                <Route path='/optiker/*' element={<RequireAuth allowedRoles={CARE_UNIT_ROLES}><OpticianListContainer/></RequireAuth>}/>
                <Route path='/rapporter/*' element={<RequireAuth allowedRoles={ADMIN_ONLY}><ReportContainer/></RequireAuth>}/>
                <Route path='/logg/*' element={<RequireAuth allowedRoles={ADMIN_ONLY}><EventListContainer/></RequireAuth>}/>
                <Route path='/anvandare' element={<RequireAuth allowedRoles={USER_ADMIN_ROLES}><UserListContainer/></RequireAuth>}/>
                <Route path='/vardenheter/*' element={<RequireAuth allowedRoles={ADMIN_ONLY}><CareUnitListContainer/></RequireAuth>}/>
            </Routes>
        </Container>
    </main>
    </div>
)

export default Main
